import classesK from '../kalkulatori.module.css'
import classes from './paroli.module.css'
import { useState } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import ResultsSection from '../redesign/components/ResultsSection'
import runCalculator from '../api/runCalculator'

const category = 'strategies'
const slug = 'paroli'

const calculatorType = 'Paroli'

const Paroli = () => {
  const [data, setData] = useState({
    values: {
      serie1: [''],
      serie2: [''],
      serie3: [''],
      stake: [''],
    },
    results: {
      serie1Results: ['', ''], // [expectedWin, profit]
      serie2Results: ['', ''],
      serie3Results: ['', ''],
    },
  })

  const [showInputArea, setShowInputArea] = useState(true)
  const series = [{ id: 1 }, { id: 2 }, { id: 3 }]
  const [ukupno, setUkupno] = useState(0)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const clearFields = () => {
    setData({
      values: {
        serie1: [''],
        serie2: [''],
        serie3: [''],
        stake: [''],
      },
      results: {
        serie1Results: ['', ''],
        serie2Results: ['', ''],
        serie3Results: ['', ''],
      },
    })
    setShowInputArea(true)
    setUkupno(0)
    setError('')
  }

  // Build the API request body from the current input state, matching the
  // golden `input` shape (English keys). Inputs are parsed with parseFloat the
  // same way the component reads them.
  const buildBody = (values) => ({
    stake: parseFloat(values.stake[0]) || 0,
    oddsList: [
      parseFloat(values.serie1?.[0]) || 1,
      parseFloat(values.serie2?.[0]) || 1,
      parseFloat(values.serie3?.[0]) || 1,
    ],
  })

  // Map the English API response (shaped like golden `output`) back into the
  // exact data.results shape the JSX consumes: series[i].potentialWin ->
  // serieNResults[0], series[i].netGain -> serieNResults[1], total -> ukupno.
  const applyResults = (out) => {
    const seriesOut = out.series || []
    const mapSerie = (s) => {
      if (!s) return ['-', '-']
      const potentialWin = s.potentialWin
      const netGain = s.netGain
      return [
        potentialWin == null ? '-' : Number(potentialWin).toFixed(2),
        netGain == null ? '-' : Number(netGain).toFixed(2),
      ]
    }

    setData((prevData) => ({
      ...prevData,
      results: {
        serie1Results: mapSerie(seriesOut[0]),
        serie2Results: mapSerie(seriesOut[1]),
        serie3Results: mapSerie(seriesOut[2]),
      },
    }))
    setUkupno(out.total == null ? 0 : out.total)
  }

  const calculateResults = async (values) => {
    setLoading(true)
    setError('')
    try {
      const out = await runCalculator(category, slug, buildBody(values))
      applyResults(out)
    } catch (e) {
      setError('Greška pri obračunu, pokušajte ponovo.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />

      <div className={classesK.contentContainer}>
        {showInputArea && (
          <>
            <div className={classesK.oddsResult}>
              <div className={classesK.resultItem}>
                <span className={classesK.resultHeader}>
                  Tvoja banka nakon tri prolazne igre
                </span>
                <span>{ukupno}</span>
              </div>
            </div>
            <div className={classesK.sectionTitle}>Igra</div>
            {series.map((serie) => (
              <div key={serie.id} className={classes.seriesContainer}>
                <div className={`${classesK.calcButton} ${classes.calcButton}`}>
                  Serija br. {serie.id}
                </div>
                <div className={classes.seriesValues}>
                  <div className={classes.oddsContainer}>
                    {serie.id === 1 && (
                      <div className={classesK.oddsContainer}>
                        <span>Upiši ulog</span>
                        <input
                          type='number'
                          min='0'
                          value={data.values.stake[0]}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value)

                            setData((prevData) => ({
                              ...prevData,
                              values: {
                                ...prevData.values,
                                stake: [value],
                              },
                            }))
                          }}
                        />
                      </div>
                    )}
                    <div className={classesK.oddsContainer}>
                      <span>Upiši kvotu</span>
                      <input
                        type='number'
                        min='0'
                        value={data?.values[`serie${serie.id}`][0] || ''}
                        onChange={(e) => {
                          const value = parseFloat(e.target.value)

                          setData((prevData) => ({
                            ...prevData,
                            values: {
                              ...prevData.values,
                              [`serie${serie.id}`]: [value],
                            },
                          }))
                        }}
                      />
                    </div>
                  </div>
                  <ResultsSection
                    names={['Eventualni dobitak', 'Plus po seriji']}
                    results={[
                      data?.results[`serie${serie.id}Results`]
                        ? data.results[`serie${serie.id}Results`][0] || '-'
                        : '-',
                      data?.results[`serie${serie.id}Results`]
                        ? data.results[`serie${serie.id}Results`][1] || '-'
                        : '-',
                    ]}
                    allowNegative={true}
                  />
                </div>
              </div>
            ))}
            <div className={classesK.addMore}>
              <button
                onClick={() => calculateResults(data.values)}
                className={classesK.addButton}
                disabled={loading}
              >
                {loading ? 'Obračun u toku...' : 'Prikaži rezultate'}
              </button>
            </div>
            {error && (
              <div className={classesK.sectionTitle}>{error}</div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default Paroli
